<template>
  <v-app id="register-form">
    <v-main>
      <v-container style="height: 100%; display: grid" :fluid="true">
        <v-row align="center" justify="center">
          <v-col xs="12" sm="8" md="6">
            <v-card class="elevation-4 card--flex-toolbar">
              <!--              <v-app-bar flat color="transparent">-->
              <v-row>
                <v-col xs12 class="text-center mt-6">
                  <v-avatar size="48" color="grey">
                    <v-icon size="20" dark>fa-solid fa-shield-check</v-icon>
                  </v-avatar>
                </v-col>
              </v-row>
              <!--              </v-app-bar>-->
              <v-card-text>
                <v-row>
                  <v-col class="px-6">
                    <v-text-field
                      v-model="code"
                      label="Invite Code"
                      type="text"
                      prepend-icon="fa-solid fa-user"
                      color="primary"
                      variant="underlined"
                    />
                  </v-col>
                </v-row>
                <!--              <v-form>-->

                <!--              </v-form>-->
              </v-card-text>
              <v-card-actions class="px-6 pb-4">
                <v-btn
                  color="primary"
                  size="large"
                  class="text-none"
                  variant="flat"
                  style="color: white !important"
                  :block="true"
                  @click="checkCode"
                >
                  Verify
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "register-form",
  data() {
    return {
      code: this.initialCode,
    };
  },
  props: {
    initialCode: {
      type: String,
      default: "",
    },
    codeError: {
      type: String,
      default: "",
    },
  },
  methods: {
    checkCode: function () {
      if (this.code !== "") {
        this.$emit("codeAdded", this.code);
      }
    },
  },
  created: function () {
    console.log("register-form: created");
  },
  computed: {},
};
</script>

<!-- styling for the component -->
<style scoped>
#login-form {
}
</style>
